import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { titleCase } from "@/lib/format";
import { roomImageForSeed } from "@/lib/stockImages";
import SectionCard, { ViewAllLink } from "./SectionCard";

export default function RecentProjects({ projects }) {
  const recent = [...projects]
    .sort((a, b) => new Date(b.updatedAt || b.createdAt) - new Date(a.updatedAt || a.createdAt))
    .slice(0, 4);

  return (
    <SectionCard testId="recent-projects" title="Recent Projects" action={<ViewAllLink to="/projects" />}>
      {recent.length === 0 ? (
        <p className="text-sm text-muted-foreground text-center py-6">No projects yet.</p>
      ) : (
        <div className="grid grid-cols-2 sm:grid-cols-3 xl:grid-cols-4 gap-3 sm:gap-4">
          {recent.map((p) => (
            <Link
              key={p._id}
              to={`/projects/${p._id}`}
              data-testid={`recent-project-${p._id}`}
              className="group rounded-xl border border-border overflow-hidden hover:shadow-md transition-shadow"
            >
              <div className="relative">
                <img src={roomImageForSeed(p._id)} alt="" className="h-28 w-full object-cover" loading="lazy" />
                {p.status && (
                  <span className="absolute top-2 left-2 rounded-md bg-card/90 backdrop-blur px-2 py-0.5 text-[11px] font-medium text-foreground">
                    {titleCase(p.status)}
                  </span>
                )}
              </div>
              <div className="p-3 flex items-end justify-between gap-2">
                <div className="min-w-0">
                  <p className="text-sm font-medium text-foreground truncate">{p.name}</p>
                  <p className="text-xs text-muted-foreground truncate">
                    {[p.city, p.bhk].filter(Boolean).join(" · ") || "—"}
                  </p>
                </div>
                <span className="h-7 w-7 rounded-full border border-border flex items-center justify-center shrink-0 group-hover:border-primary group-hover:text-primary transition-colors">
                  <ArrowRight className="h-3.5 w-3.5" />
                </span>
              </div>
            </Link>
          ))}
        </div>
      )}
    </SectionCard>
  );
}
